import { getValue } from "../../utils/object.utils";

export const transformSubjectListTableData = (
  subjectList: Array<any>
): any[] => {
  const transformDatForTable = subjectList.map((subject: any): any => {
    return {
      id: subject.id,
      name: getValue(subject, "name", ""),
      subject_type: getValue(subject, "subject_type", ""),
      subject_type_title: getValue(subject, "subject_type_title", ""),
      subject_details: getValue(subject, "subject_details", []),
    };
  });
  return transformDatForTable;
};
